import { render, staticRenderFns } from "./Prijave.vue?vue&type=template&id=b62374ca&scoped=true&"
import script from "./Prijave.vue?vue&type=script&lang=js&"
export * from "./Prijave.vue?vue&type=script&lang=js&"
import style0 from "./Prijave.vue?vue&type=style&index=0&id=b62374ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62374ca",
  null
  
)

export default component.exports